import { createSelector } from 'reselect';
import { getCart, selectCarts } from '@nike/ux-tread-cart-redux';
import crcCodes from '@nike/ux-tread-crc-code/lib/buy/carts/v2/crcCodes';

export const getCartPromotionCodesDetails = createSelector(
  getCart, // just a note that we are getting this state from outside
  cart => cart?.promotionCodesDetails || [], // react seems to throw an error when destructuring here in connect so let's leverage optional chaining instead
);

export const getCartPromotionCodes = createSelector(
  getCart, // just a note that we are getting this state from outside
  cart => cart?.promotionCodes || [], // react seems to throw an error when destructuring here in connect so let's leverage optional chaining instead
);

export const getCartWarnings = createSelector(selectCarts, carts => carts?.warnings || []);

export const getFilteredCartWarnings = createSelector(
  getCartWarnings,
  (state, props) => props.warningsToInclude || [],
  (warnings, warningsToInclude) =>
    warnings.filter(({ crcCode }) => crcCode && warningsToInclude.indexOf(crcCode) > -1),
);

export const getLatestCartWarning = createSelector(
  getFilteredCartWarnings,
  warnings => warnings[0],
);

export const getWarningRelatedPromoDetail = createSelector(
  getLatestCartWarning,
  getCartPromotionCodes,
  getCartPromotionCodesDetails,
  (warning, promoCodes, promoCodeDetails) => {
    if (warning?.crcCode === crcCodes.PROMOTION_NOT_APPLIED) {
      const { field } = warning;

      const promoIndex = field?.split('/')?.pop(); // eg: {field: "/promotionCodes/0"} -> .split ['promotionCodes', '0'] -> .pop '0'
      if (promoIndex) {
        const promoCode = promoCodes[promoIndex];
        const promoDetail = promoCodeDetails.filter(({ code }) => code === promoCode)[0];

        return promoDetail;
      }
    }
    return {};
  },
);
